import React, { useRef, useState } from 'react';
import CommonContainer from '../../common/CommonContainer';
import AdministrationPageForm from './AdministrationPageForm';
import { bindActionCreators, compose } from 'redux';
import withStyles from '@material-ui/core/styles/withStyles';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { connect } from 'react-redux';
import {
  checkIfCustomerCodeExists,
  clearAdministrationData,
  clearAdministrationExtraData,
  fetchAdministrationData,
  fetchAdministrationExtraData,
  fetchVATOptions,
  fetchDictionaries,
  fetchAdministrationListData,
  removeAdministrationItem,
  updateAdministrationItem,
  removeAdministrationCategory,
  exportAdministrationDataToExcel,
} from '../../../actions/administration/administration-actions';
import { Paper } from '@material-ui/core';
import { Form, Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import CommonButton from '../../common/CommonButton';
import {
  ALMOST_WHITE_COLOR,
  BACKGROUND_DARK,
  BACKGROUND_WHITE, BLACK_COLOR, DARK_CUSTOM,
  DODGER_BLUE,
  GREEN_COLOR,
  RED_COLOR,
  WHITE_COLOR,
} from '../../../const/color-const';
import AddNewItemDialog, { sectionWrapperStyles } from './AddNewItemDialog';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import LoadingSnackbar from '../../common/LoadingSnackbar';
import AdministrationItemsFormFields, {
  ADMINISTRATION_DATA_TYPE,
  getDefaultValueForFieldType,
  sliceRows,
} from './AdministrationItemsFormFields';
import CommonPagination from '../../common/CommonPagination';
import Switch from '@material-ui/core/Switch/Switch';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import classNames from 'classnames';
import { removeInventoryItem } from '../../../actions/administration/articles-actions';
import { LOCAL_STORAGE_MACHINE_ID } from '../../../actions/auth-actions';
import CommonSnackbar from '../../common/CommonSnackbar';
import Box from '@material-ui/core/Box';
import NoDataAvailableWithIcon from '../../common/charts/NoDataAvailableWithIcon';
import { AddOutlined } from '@material-ui/icons';

const styles = (theme) => ({
  formContent: {
    maxHeight: 100,
    padding: theme.spacing(0),
    transition: 'max-height 1s ease-in-out',
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 0, 1, 0),
      maxHeight: '100%',
      overflow: 'visible',
    },
  },
  expanded: {
    background: 'transparent',
    maxHeight: 5000,
    overflow: 'visible',
  },
  ...sectionWrapperStyles(theme),
  accordionArrow: {
    background: theme.palette.type === 'light' ? BACKGROUND_WHITE : BACKGROUND_DARK,
    border: theme.palette.type === 'light' ? `1px solid ${ALMOST_WHITE_COLOR}` : `none`,
    transition: 'all 0.4s ease',
    position: 'absolute',
    cursor: 'pointer',
    borderRadius: 20,
    color: DODGER_BLUE,
    zIndex: 100,
    width: 26,
    height: 26,
    right: 15,
    top: 40,
  },
  accordionOpened: {
    transform: 'rotate(180deg)',
  },
  paper: {
    background: theme.palette.type === 'light' ? WHITE_COLOR : DARK_CUSTOM,
    margin: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
    padding: theme.spacing(2, 2, 0, 2),
    textAlign: 'center',
    position: 'relative',
  },
  contentWrapper: {
    textAlign: 'left',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  topPanel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(4),
    '& button': {
      color: GREEN_COLOR,
      borderColor: GREEN_COLOR,
      background: theme.palette.type === 'light' ? 'white' : BACKGROUND_DARK,
      '& svg': {
        width: 22,
      },
    },
  },
  removeItemSectionWrapper: {
    position: 'absolute',
    top: 0,
    height: '100%',
    width: '100%',
    backdropFilter: 'blur(6px)',
    background: 'rgba(255, 255, 255, 0.2)',
    zIndex: 99,
  },
  removeItemSection: {
    position: 'flex',
    alignContent: 'center',
    width: '100%',
    height: '100%',
    fontSize: 16,
    fontWeight: 'bold',
    display: 'grid',
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1, 0, 1, 0),
  },
  reportHeader: {
    paddingTop: theme.spacing(3),
  },
  redButton: {
    width: 120,
    color: RED_COLOR,
    borderColor: RED_COLOR,
  },
  button: {
    width: 120,
  },
  noDataFound: {
    marginTop: theme.spacing(4),
    fontSize: 16,
  },
  selectCashRegister: {
    width: 320,
    background: theme.palette.type === 'light' ? 'white' : BLACK_COLOR,
  },
});

export const ITEMS_PER_PAGE = 20;

const CommonAdministrationPage = (props) => {
  const {
    machines,
    type,
    title,
    checkIfCustomerCodeExists,
    fetchAdministrationData,
    updateAdministrationItem,
    removeAdministrationItem,
    removeInventoryItem,
    removeAdministrationCategory,
    clearAdministrationData,
    clearAdministrationExtraData,
    fetchAdministrationExtraData,
    fetchAdministrationListData,
    fetchVATOptions,
    fetchDictionaries,
    exportAdministrationDataToExcel,
    administrationData,
    administrationExtraData,
    administrationListData,
    vatOptions,
    dictionaries,
    classes,
    fields,
  } = props;
  
  const masterMachines = machines.filter(machine => machine.IsSyncMachine);
  const machinesOptions = masterMachines.map(machine => ({ label: machine.Name, value: machine.Id }));
  const [loadingProgress, setLoadingProgress] = useState(null);
  const [page, setPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const isBongCategoryPage = type === 'BongCategory';
  const [advancedMode, setAdvancedMode] = useState(isBongCategoryPage);
  const [accordion, setAccordion] = useState([]);
  const [formValues, setFormValues] = useState(null);
  const [itemsToRemove, setItemsToRemove] = useState([]);
  const [newlyCreatedItemName, setNewlyCreatedItemName] = useState(null);
  const [isDirty, setDirty] = useState(false);
  const { formatMessage } = useIntl();
  const [machineId, setMachineId] = useState(localStorage.getItem(LOCAL_STORAGE_MACHINE_ID) || machinesOptions[0]?.value);
  const prevMachineId = React.useRef(machineId);
  const formRef = useRef();
  
  const handleMachineIdChange = ({ target: { value: newMachineId } }) => {
    setMachineId(newMachineId);
    localStorage.setItem(LOCAL_STORAGE_MACHINE_ID, newMachineId);
  };
  
  React.useEffect(() => {
    const { INVENTORY_TABLE, CATEGORY_TABLE, BONG_CATEGORY_TABLE } = ADMINISTRATION_DATA_TYPE;
    if (type === INVENTORY_TABLE && (!administrationExtraData || Object.keys(administrationExtraData).length === 0)) {
      fetchAdministrationExtraData(type, machineId);
    }
    if (type === CATEGORY_TABLE && !administrationListData) fetchAdministrationListData([CATEGORY_TABLE, BONG_CATEGORY_TABLE], machineId);
  }, [administrationExtraData, administrationListData, fetchAdministrationExtraData, fetchAdministrationListData, type, machineId]);
  
  React.useEffect(() => {
    if (!vatOptions) fetchVATOptions();
    if (!dictionaries) fetchDictionaries(machineId);
  }, [fetchVATOptions, fetchDictionaries, machineId, vatOptions, dictionaries]);
  
  React.useEffect(() => {
    clearAdministrationData();
    if (machineId !== prevMachineId.current) {
      clearAdministrationExtraData();
      prevMachineId.current = machineId;
    }
  }, [clearAdministrationData, clearAdministrationExtraData, machineId, type]);
  
  const cashRegisterSelect = <Select
    className={classes.selectCashRegister}
    variant="outlined"
    value={machineId} onChange={(event) => handleMachineIdChange(event)}>
    {machinesOptions.map(machine => (
      <MenuItem value={machine.value} key={machine.value}>{machine.label}</MenuItem>
    ))}
  </Select>;
  
  const administrationDataItems = administrationData?.items;
  const hasAdministrationExtraDataIfNeeded = type !== ADMINISTRATION_DATA_TYPE.INVENTORY_TABLE || (administrationExtraData && Object.keys(administrationExtraData).length > 0);
  
  function getCommonPagination() {
    return <CommonPagination
      page={page}
      itemsFrom={administrationData.itemsFrom}
      itemsTo={administrationData.itemsTo}
      pageCount={administrationData.pageCount}
      onChange={(event, value) => {
        setPage(value);
        switch (type) {
          default:
            return fetchAdministrationData(type, machineId, formRef.current.values, value - 1, formRef.current.formikHelpers && formRef.current.formikHelpers.setSubmitting, setLoadingProgress);
        }
      }}
      totalCount={administrationData.totalCount}
    />;
  }
  
  return (
    <CommonContainer hAlign="center">
  
      <h1 className={classes.reportHeader}>
        {title}
      </h1>
  
      <AdministrationPageForm
        innerRef={formRef}
        cashRegisterSelect={cashRegisterSelect}
        handleSubmit={(values, formikHelpers) => {
          setFormValues(values);
          setPage(1);
          switch (type) {
            default:
              return fetchAdministrationData(type, machineId, values, page - 1, formikHelpers.setSubmitting, setLoadingProgress);
          }
        }}
      />
  
      <LoadingSnackbar
        progress={loadingProgress}
        label={<FormattedMessage id="loading" defaultMessage="Loading" />}
      />
      <div className={classes.contentWrapper}>
        <div className={classes.topPanel}>
          <CommonButton
            variant="outlined"
            onClick={() => setOpenDialog(true)}
            label={
              <>
                <FormattedMessage id="page.administration.addNewItem" defaultMessage="Add new item" />
                &nbsp;
                <AddOutlined />
              </>
            }
          />
  
          <CommonButton
            variant="outlined"
            onClick={() => exportAdministrationDataToExcel(type, machineId, setLoadingProgress, formValues)}
            label={
              <>
                <FormattedMessage id="page.administration.excel" defaultMessage="Excel" />
                &nbsp;
                <FileDownloadOutlinedIcon />
              </>
            }
            disabled={!formValues}
          />
  
          {hasAdministrationExtraDataIfNeeded &&
          <AddNewItemDialog
            checkIfCustomerCodeExists={checkIfCustomerCodeExists}
            administrationExtraData={administrationExtraData}
            administrationListData={administrationListData}
            searchText={administrationData && administrationData.searchText}
            fields={fields.filter(field => !field.onlyOnUpdate)}
            open={openDialog}
            setLoadingProgress={setLoadingProgress}
            page={page}
            setOpenDialog={setOpenDialog}
            type={type}
            machineId={machineId}
            advancedMode={advancedMode}
            setAdvancedMode={setAdvancedMode}
            vatOptions={vatOptions}
            dictionaries={dictionaries}
            renderAdvancedSwitch={!isBongCategoryPage}
            setDirty={setDirty}
            isDirty={isDirty}
            setNewlyCreatedItemName={setNewlyCreatedItemName}
          />}
  
          {!isBongCategoryPage && <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Switch color="primary" checked={advancedMode} onChange={() => setAdvancedMode(!advancedMode)} />
            <span>
            <FormattedMessage id="page.administration.advancedOptions" defaultMessage="Advanced options" />
            </span>
          </Box>}

        </div>
  
        {administrationData?.items?.length > 0 && hasAdministrationExtraDataIfNeeded &&
        (
          <>
            {getCommonPagination()}
            {administrationDataItems.map((item, index) => {
              let rows = sliceRows(fields.filter(fieldToFilter => !(!advancedMode && !fieldToFilter.basic)));
              return <Paper key={index} className={classes.paper} elevation={2}>
                <Formik
                  enableReinitialize
                  initialValues={{
                    ...item, ...fields.filter(field => !Object.keys(item).includes(field.name)).reduce((obj, element) => Object.assign(obj,
                      {
                        [element.name]: ((element.initialValue && element.initialValue !== true) || element.initialValue === 0)
                          ? element.initialValue :
                          getDefaultValueForFieldType(element.type),
                      }), {}),
                  }}
                  onSubmit={(values, formikHelpers) => {
                    if (type !== ADMINISTRATION_DATA_TYPE.GIFT_CARD_TABLE || (!values.CustomerCode || checkIfCustomerCodeExists(machineId, values, formikHelpers.setSubmitting, formikHelpers.setFieldError, setLoadingProgress))) {
                      switch (type) {
                        default:
                            return updateAdministrationItem(type, administrationData.machineId, values, formikHelpers.setSubmitting, page - 1, setLoadingProgress, administrationData.searchText);
                        }
                      }
                    }}>
                    {({ isSubmitting, setSubmitting, dirty, setFieldValue, values }) => {
                      return (
  
                        <Form className={classNames(
                          classes.formContent,
                          accordion.includes(index) && classes.expanded)}>
                          <AdministrationItemsFormFields
                            values={values}
                            rows={rows}
                            classes={classes}
                            administrationExtraData={administrationExtraData}
                            administrationListData={administrationListData}
                            setFieldValue={setFieldValue}
                            vatOptions={vatOptions}
                            dictionaries={dictionaries}
                            isUpdate={true}
                            setDirty={setDirty}
                            itemIndex={index}
                            accordion={accordion}
                            setAccordion={setAccordion}
                          />
                          
                          {itemsToRemove.includes(item.Id) &&
                          <div className={classes.removeItemSectionWrapper}>
                            <div className={classes.removeItemSection}>
                              <FormattedMessage
                                id="page.administration.deleteItem"
                                defaultMessage="Are you sure you want to delete this item?"
                              />
                              <div className={classes.buttonsWrapper}>
                                <CommonButton
                                  variant="outlined"
                                  className={classes.button}
                                  color="secondary"
                                  onClick={() =>
                                    setItemsToRemove(itemsToRemove.filter(itemToRemove => itemToRemove !== item.Id))}
                                  label={
                                    <FormattedMessage
                                      id="button.cancel"
                                      defaultMessage="Cancel"
                                    />
                                  }
                                />
                                
                                <CommonButton
                                  variant="outlined"
                                  className={classes.redButton}
                                  onClick={() => {
                                    setItemsToRemove(itemsToRemove.filter(itemToRemove => itemToRemove !== item.Id));
                                    switch (type) {
                                      case ADMINISTRATION_DATA_TYPE.CATEGORY_TABLE:
                                        return removeAdministrationCategory(type, administrationData.machineId, item.Id, setSubmitting, page - 1, setLoadingProgress, administrationData.searchText);
                                      case ADMINISTRATION_DATA_TYPE.INVENTORY_TABLE:
                                        return removeInventoryItem(type, administrationData.machineId, item.Id, setSubmitting, page - 1, setLoadingProgress, administrationData.searchText);
                                      default:
                                        return removeAdministrationItem(type, administrationData.machineId, item.Id, setSubmitting, page - 1, setLoadingProgress, administrationData.searchText);
                                    }
                                  }}
                                  label={
                                    <FormattedMessage
                                      id="button.yes"
                                      defaultMessage="Yes"
                                    />
                                  }
                                />
                              
                              </div>
                            </div>
                          </div>
                          }
                          
                          <div className={classes.buttonsWrapper}>
                            <CommonButton
                              variant="outlined"
                              className={classes.redButton}
                              onClick={() => setItemsToRemove([...itemsToRemove, item.Id])}
                              label={
                                <FormattedMessage
                                  id="button.remove"
                                  defaultMessage="Remove"
                                />
                              }
                              disabled={type === ADMINISTRATION_DATA_TYPE.GIFT_CARD_TABLE && values.Balance > 0}
                            />
                            
                            <CommonButton
                              variant="outlined"
                              color="secondary"
                              type="submit"
                              className={classes.button}
                              label={
                                <FormattedMessage
                                  id="button.save"
                                  defaultMessage="Save"
                                />
                              }
                              disabled={!dirty || isSubmitting}
                              onClick={() => setDirty(false)}
                            />

                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </Paper>;
              },
            )}
            <Prompt
              when={isDirty}
              message={() => formatMessage({
                id: 'confirmation.prompt',
                defaultMessage: 'Are you sure you want to leave without saving?',
              })}
            />
            {getCommonPagination()}
          </>)}
  
        {newlyCreatedItemName && <CommonSnackbar
          open={true}
          title={<FormattedMessage id="success" defaultMessage="Success" />}
          message={<FormattedMessage id="administration.item.saved" defaultMessage='"{item}" saved!'
                                     values={{ item: newlyCreatedItemName }} />}
          onExtraClose={() => setNewlyCreatedItemName(null)}
        />}
  
        {!!administrationDataItems && administrationDataItems.length === 0 &&
        <CommonContainer className={classes.noDataFound}>
          <NoDataAvailableWithIcon
            customText={<FormattedMessage id="report.title.NoDataFound" defaultMessage="No data found" />} />
        </CommonContainer>}
      </div>
    </CommonContainer>);
};

const decorate = compose(
  withStyles(styles),
  connect(
    store => ({
      machines: store.user.machines,
      administrationData: store.administrationData.administrationData,
      administrationExtraData: store.administrationData.administrationExtraData,
      administrationListData: store.administrationData.administrationListData,
      vatOptions: store.administrationData.vatOptions,
      dictionaries: store.administrationData.dictionaries,
    }),
    dispatch => bindActionCreators({
      fetchAdministrationData,
      updateAdministrationItem,
      removeAdministrationItem,
      removeInventoryItem,
      removeAdministrationCategory,
      clearAdministrationData,
      clearAdministrationExtraData,
      fetchAdministrationExtraData,
      fetchAdministrationListData,
      checkIfCustomerCodeExists,
      fetchVATOptions,
      fetchDictionaries,
      exportAdministrationDataToExcel,
    }, dispatch)),
);

CommonAdministrationPage.propTypes = {
  machines: PropTypes.array,
  administrationData: PropTypes.object,
  administrationExtraData: PropTypes.object,
  fields: PropTypes.array.isRequired,
  classes: PropTypes.object,
  type: PropTypes.string.isRequired,
  title: PropTypes.object.isRequired,
  checkIfCustomerCodeExists: PropTypes.func,
  fetchAdministrationData: PropTypes.func,
  updateAdministrationItem: PropTypes.func,
  removeAdministrationItem: PropTypes.func,
  removeAdministrationCategory: PropTypes.func,
  removeInventoryItem: PropTypes.func,
  clearAdministrationData: PropTypes.func,
  clearAdministrationExtraData: PropTypes.func,
  fetchAdministrationExtraData: PropTypes.func,
  fetchAdministrationListData: PropTypes.func,
  fetchVATOptions: PropTypes.func,
  vatOptions: PropTypes.array,
  fetchDictionaries: PropTypes.func,
  exportAdministrationDataToExcel: PropTypes.func,
  dictionaries: PropTypes.array,
};

export default decorate(CommonAdministrationPage);